var _a;
import { createLaunchDarklyContext } from "@adsk/alloy-provider";
export var LaunchDarklyProvider =
    ((_a = createLaunchDarklyContext()), _a.LaunchDarklyProvider),
  useFeatureFlag = _a.useFeatureFlag;
